import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrl: './form-input.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class FormInputComponent {
  @Input() form!: FormGroup;
  @Input() controlName!: string;

  @Input() label!: string;
  @Input() placeholder = '';
  @Input() type: string = 'text';
  @Input() submitted = false;
  @Input() options: string[] = []; // Add this to support datalists
  @Input() readonly = false;
  constructor(public controlContainer: ControlContainer) {}
   get control() {
    return this.controlContainer.control?.get(this.controlName);
  }
  showNewPassword = false;

toggleNewPassword() {
  this.showNewPassword = !this.showNewPassword;
  this.getInputType();
}
  getInputType(): string {
    if (this.type === 'password') {
      return this.showNewPassword ? 'text' : 'password';
    }
    return this.type === 'phone' ? 'tel' : this.type;
  }
}
